var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-card",
    { staticClass: "cardClassDetailForm", attrs: { title: "개선 사진" } },
    [
      _c("template", { slot: "card-detail" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c("c-upload", {
              attrs: {
                label: "개선 전 사진",
                attachInfo: _vm.attachBeforeInfo,
                editable: _vm.editable && !_vm.popupParam.disabled,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c("c-upload", {
              attrs: {
                label: "개선 후 사진",
                attachInfo: _vm.attachAfterInfo,
                editable: _vm.editable && !_vm.popupParam.disabled,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }